/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Run_Subject_ClaimsInputs */



/**
* | output |
* | --- |
* | "Accepted claims" |
*
* @param {Leveling_Run_Subject_ClaimsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_run_subject_claims = /** @type {((inputs?: Leveling_Run_Subject_ClaimsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Run_Subject_ClaimsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Принятые заявки")
	return /** @type {LocalizedString} */ ("Accepted claims")
});